import { SIZE_FULL } from '@/lib/gridElements/size';

import { HeatMapChart } from '@/components/composite/Charts/HeatMapChart';

export const bestTimeToPostConfig = {
    minWidth: 750,
    name: {
        day: 'chart.best_time_to_post.engagement_more',
        value: 'chart.best_time_to_post.engagement_less'
    },
    isPercentValue: true,
    noTableView: true,
    id: 'best_time_to_post',
    color: {
        value: 'white'
    },
    defaultFilter: 'engagement_rate_followers',
    filters: {
        engagement_rate_followers: {
            title: 'chart.facebook.best_time_to_post_engagement_followers',
            menu: 'chart.facebook.best_time_to_post_engagement_followers_filter'
        }
    },
    colors: {
        light: {
            blue200: '#96D8FF',
            blue300: '#33a1ff',
            blue400: '#1a95ff',
            blue: '#0089ff'
        },
        dark: {
            blue200: '#11263F',
            blue300: '#0E3861',
            blue400: '#085BA5',
            blue: '#0089ff'
        }
    },
    legendType: 'bttp',
    tooltipTranslation: {
        filtersToken: {
            engagement_rate_followers:
                'chart.facebook.best_time_to_post_engagement_followers_tooltip_chart'
        },
        values: ['date', 'day', 'value', 'count_posts']
    },
    legendHighlightValueTranslation: {
        token: 'chart.facebook.best_time_to_post_engagement_legend_highlight',
        values: ['date', 'day']
    },
    tooltip: 'chart.facebook.tooltip_best_time_to_post_engagement',
    size: SIZE_FULL,
    type: 'chart',
    iconHighestValue: 'star',
    margin: { bottom: 10, left: -30 },
    breakpoints: [
        { color: 'blue200', r: 3.5 },
        { color: 'blue300', r: 7.5 },
        { color: 'blue400', r: 12.5 },
        { color: 'blue', r: 12.5 }
    ],
    element: HeatMapChart
};
